<template>
  <div class="delete-modal">
    <h2 class="delete-modal__title">{{ title }}</h2>

    <div class="main-form__buttons main-form__buttons_center">
      <span
        @click="$emit('cancel')"
        class="main-button main-button_cancel main-button_mr10"
      >
        {{ $t("global.cancel") }}
      </span>
      <span
        @click="$emit('next')"
        class="main-button main-button_success main-button_ml10"
      >
        {{
          cancelDeletionTag === true ? "Cancel request" : $t("global.delete")
        }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        cancelDeletionTag: {
            required: false,
            default: false,
            type: Boolean,
        },
        title: {
            required: true,
            type: String,
        },
    },
}
</script>

<style lang="scss" scoped>
.delete-modal {
  width: 540px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 34px;

  &__title {
    padding: 20px;
    font-family: "SFUIDisplay-Medium";
    font-size: 36px;
    color: #71bd4a;
    text-align: center;
    max-width: 515px;
    line-height: 1.2;
    margin: 0;
  }

  &__buttons {
    display: flex;
    justify-content: center;
  }
}
</style>
